import { Spinner } from "components/DesignSystem/Loader/loader";
import { Check } from "components/icons/Check";
import { useIncorporationSaveStatus } from "./useIncorporationSaveStatus";
import { TickSlim } from "components/icons/TickSlim";

export const IncorporationSaveStatus = () => {
  const { isLoading, isSuccess } = useIncorporationSaveStatus();

  if (isLoading) {
    return (
      <div className="t-flex t-items-center t-gap-1.5 t-text-body-sm t-text-text-30">
        <Spinner size="small" />
        Saving...
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="t-flex t-items-center t-gap-1.5 t-text-body-sm t-text-text-30">
        <TickSlim />
        Your progress is saved
      </div>
    );
  }

  return null;
};
